import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  container: {
    paddingRight: 40
  },
  principales: {
    marginLeft: 0,
    paddingLeft: 0,
    paddingBottom: 30,
  },
}));

export default styles;
